import { useSyncExternalStore } from 'react';
import { getConsent, subscribeConsent } from './context.js';

export function useTrackingConsent(): boolean {
  return useSyncExternalStore(subscribeConsent, getConsent, getServerSnapshot);
}

function getServerSnapshot(): boolean {
  return false;
}
